import { createTheme } from '@material-ui/core/styles';

export const themeLight = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#2c6690',
      light: 'lightblue',
    },
    background: {
      default: '#f7f9fc',
    },
    text: {
      primary: '#333',
    },
  },
});

export const themeDark = createTheme ({
  palette: {
    type: 'dark',
    primary: {
      main: '#58a6ff',
      light: '#82bfff',
    },
    background: {
      default: '#303030',
    },
    text: {
      primary: '#fff',
    },
  },
});
